module.exports = __webpack_public_path__ + "ath_game_web/img/7.4.16f12d6e.png";